
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover-apps",
      function () {
        return require("private-next-pages/discover-apps.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover-apps"])
      });
    }
  